module.exports = __webpack_public_path__ + "static/media/Hidden-Timbers-bylaws.5545a719.pdf";